import React from 'react';

import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework"
import API from "@beardeddevops/react.api";
import {Objects, Collections} from "components";

import {Button} from "reactstrap";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import UniversalModalOverride from "components/UniversalModalOverride";
import Access from "constants/Access";


const defaultIdentification = {
	alternate_documentation: '',
	customer: -1,
	identification_authority: '',
	identification_expiration: '',
	identification_issue: '',
	identification_number: '',
	identification_type: '',
	image: '',
	image_back: '',
	non_immigrant_visa_prohibition: '',
	pkey: -1,
};

const defaultPermit = {
	customer: -1,
	expiration: '',
	image: '',
	image_back: '',
	issue: '',
	number: '',
	pkey: -1,
	state: '',
	type: '',
}

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Customers',
		url: '/customers',
		icon: 'users',
	}
];

class Customer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');

		this.dispositionsPendingModel = new API.BuildClass(Types.Dispositions_Pendings._name, 'GET_EDITING');

		this.state.phones = [];
		this.state.addresses = [];
		this.state.emails = [];
		this.state.blacklist = [];
		this.state.militaries = [];
		this.state.permit = {...defaultPermit};
		this.state.identification = {...defaultIdentification};
		this.state.modalAddress = false;
		this.state.modalMilitary = false;
		this.state.modalEmail = false;
		this.state.modalNumber = false;
		this.state.modalKiosk = false;

		this.state.inKiosk = false;
		this.state.crmData = null;
	}

	componentDidMount() {
		this.getKioskStatus().then();
	}

	getKioskStatus = async () => {
		let {inKiosk} = this.state;
		let {id} = this.props.match.params;
		let [customer_binary_id, customer] = id.split('-');
		let kioskEntries;

		// Fetch the current pending dispositions associated with the selected customer,
		// and if found disable the "Send to Kiosk" button by setting the `inKiosk` state to true.

		customer = parseInt(customer);

		Object.assign(this.dispositionsPendingModel.object, {
			customer,
			customer_binary_id,
		});

		try {
			kioskEntries = await this.dispositionsPendingModel.submit(null, 'GET_EDITING');
		} catch (e) {
			return;
		}

		for (let i = 0, len = kioskEntries.items.length; i < len; i++) {
			let kioskEntry = kioskEntries.items[i];

			if (kioskEntry.customer === customer && kioskEntry.customer_binary_id === customer_binary_id) {
				inKiosk = true;
				break;
			}
		}

		if (inKiosk) this.setState({inKiosk});
	}

	loadContacts = (contacts) => {
		if (contacts) {
			this.setState({
				phones: contacts.phones,
				addresses: contacts.addresses,
				emails: contacts.emails,
				blacklist: contacts.blacklist,
				permit: contacts.permit,
				identification: contacts.identification,
				militaries: contacts.militaries,
			});
		}
	}

	//CRM: receives the full customer object from CustomerEdit.loadSelfAfter so the CRM tab
	//can render tracked fields (language, opt-ins + audit dates, last contact) without a
	//second API call. Read-only.
	loadCrmData = (data) => {
		if (data) {
			this.setState({crmData: data});
		}
	}

	handleAddressSave = (address) => {
		const {addresses} = this.state;

		addresses.push(address);

		this.setState({addresses});
	}

	handleMilitarySave = (military) => {
		this.setState({militaries: [military]});
	}
	handleEmailSave = (email) => {
		const {emails} = this.state;

		emails.push(email);

		this.setState({emails});
	}
	handlePhoneSave = (phone) => {
		const {phones} = this.state;

		phones.push(phone);

		this.setState({phones});
	}

	handleAddressDeletion = (pkey, binary_id) => {
		const {addresses} = this.state;
		const index = addresses.findIndex((address) => address.pkey === pkey && address.binary_id === binary_id);

		if (index > -1 && addresses[index]) {
			addresses.splice(index, 1);
		}

		this.setState({addresses});
	}
	handleMilitaryDeletion = () => {
		this.setState({militaries: []});
	}
	handleEmailDeletion = (pkey, binary_id) => {
		const {emails} = this.state;
		const index = emails.findIndex((email) => email.pkey === pkey && email.binary_id === binary_id);

		if (index > -1 && emails[index]) {
			emails.splice(index, 1);
		}

		this.setState({emails});
	}
	handlePhoneDeletion = (pkey, binary_id) => {
		const {phones} = this.state;
		const index = phones.findIndex((phone) => phone.pkey === pkey && phone.binary_id === binary_id);

		if (index > -1 && phones[index]) {
			phones.splice(index, 1);
		}

		this.setState({phones});
	}

	handleIdentificationSave = (identification) => {
		this.setState({identification});
	}
	handleIdentificationDeletion = () => {
		this.setState({identification: {...defaultIdentification}});
	}
	handleNicsPermitSave = (permit) => {
		this.setState({permit});
	}
	handleNicsPermitDeletion = () => {
		this.setState({permit: {...defaultPermit}});
	}

	handleToggleModalAddress = () => {

		let nextState = {modalAddress: true};
		if (this.state.tab !== 'contact') nextState.tab = 'contact';
		this.setState(nextState);
	}
	handleToggleModalMilitary = () => {

		let nextState = {modalMilitary: true};
		if (this.state.tab !== 'contact') nextState.tab = 'contact';
		this.setState(nextState);
	}
	handleToggleModalEmail = () => {

		let nextState = {modalEmail: true};
		if (this.state.tab !== 'contact') nextState.tab = 'contact';
		this.setState(nextState);
	}
	handleToggleModalNumber = () => {

		let nextState = {modalNumber: true};
		if (this.state.tab !== 'contact') nextState.tab = 'contact';
		this.setState(nextState);
	}

	handleSendToKiosk = () => {
		this.setState({loading: true});

		let dpModel = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.READ);
		dpModel.parent = this.props.match.params.id;

		dpModel.submit(null, 'PUT_CUSTOMER').then(() => {
			this.props.history.push("/dispositions/pendings");
			this.setState({loading: false});
		}).catch(() => {
			this.setState({loading: false});
		});
	}

	handleTab = () => {
		this.setState({tab: "History"});
	}

	render() {


		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/customers/${this.props.id}`,
				icon: 'users',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{this.state.blacklist !== true &&
					<Button onClick={this.toggle('modalBlacklist')} size="sm" color="danger">
						<i className="fa fa-times"/>&nbsp;&nbsp;Blacklist
					</Button>}

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						id={this.props.match.params.id}
						name="Blacklist"
						object={Objects.CustomerBlacklist}
						history={this.props.history}
						toggle={this.state['modalBlacklist']}
						reportClose={this.reportClose('modalBlacklist')}
						afterSave={this.handleAfterSave}
						size="md"
						hideGoTo={true}
					/>

					{/*Only Allow One Address*/}

					{this.state.militaries.length <0
					&&<Button onClick={this.handleToggleModalMilitary} size="sm" color="primary">
						<i className="fa fa-flag"/>&nbsp;&nbsp;Add Military Addr. / PCS
					</Button>}

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						parent={this.props.match.params.id}
						name="Military Address"
						object={Objects.CustomerMilitary}
						history={this.props.history}
						toggle={this.state['modalMilitary']}
						reportClose={this.reportClose('modalMilitary')}
						afterSave={this.handleMilitarySave}
						size="md"
					/>

					<Button onClick={this.handleToggleModalAddress} size="sm" color="primary">
						<i className="fa fa-map-marker"/>&nbsp;&nbsp;Add Address
					</Button>

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						parent={this.props.match.params.id}
						name="Address"
						object={Objects.CustomerAddress}
						history={this.props.history}
						toggle={this.state['modalAddress']}
						reportClose={this.reportClose('modalAddress')}
						afterSave={this.handleAddressSave}
						size="md"
					/>

					<Button onClick={this.handleToggleModalEmail} size="sm" color="primary">
						<i className="fa fa-at"/>&nbsp;&nbsp;Add Email
					</Button>

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						parent={this.props.match.params.id}
						name="Email"
						object={Objects.CustomerEmail}
						history={this.props.history}
						toggle={this.state['modalEmail']}
						reportClose={this.reportClose('modalEmail')}
						afterSave={this.handleEmailSave}
						size="sm"
					/>

					<Button onClick={this.handleToggleModalNumber} size="sm" color="primary">
						<i className="fa fa-phone"/>&nbsp;&nbsp;Add Number
					</Button>

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						parent={this.props.match.params.id}
						name="Phone Number"
						object={Objects.CustomerPhone}
						history={this.props.history}
						toggle={this.state['modalNumber']}
						reportClose={this.reportClose('modalNumber')}
						afterSave={this.handlePhoneSave}
						size="sm"
					/>

					{/*<Button*/}
					{/*	onClick={this.handleSendToKiosk}*/}
					{/*	size="sm"*/}
					{/*	color="primary"*/}
					{/*	disabled={inKiosk}>*/}
					{/*	<i className="fa fa-arrow-left"/>&nbsp;&nbsp;Send to Kiosk*/}
					{/*</Button>*/}
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Customer" value="details"/>
					<Tab label="Contact" value="contact"/>
					<Tab label="Identification" value="identification"/>
					<Tab label="History" value="history"/>
					{this.props.userAccess <Access.Supervisor&&<Tab label="Change Log" value="logs"/>}
					<Tab label="Possible Duplicate" value="duplicates"/>
					{(this.props.rootState && this.props.rootState.crmAvailable) && <Tab label="CRM" value="crm"/>}
					</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.CustomerEdit
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						loadContacts={this.loadContacts}
						loadCrmData={this.loadCrmData}
						afterSave={this.loadCrmData}
						baseUrl={this.props.baseUrl}
						/>
						</div>
				{this.state.tab === 'contact' &&
				<div className={'row'}>
					{this.state.addresses.length > 0 && <div className={'col-3'}>
						{this.state.addresses.map((address, i) =>
							<Objects.CustomerAddress
								key={i}
								id={address.pkey}
								binary_id={address.binary_id}
								parent={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								address={address}
								dataIdSave="AddressSave"
								afterDelete={this.handleAddressDeletion}
							/>
						)}
					</div>}
					{this.state.militaries.length > 0 && <div className={'col-3'}>
						{this.state.militaries.map((military, i) =>
							<Objects.CustomerMilitary
								key={i}
								id={military.pkey}
								binary_id={military.binary_id}
								parent={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								military={military}
								dataIdSave="MilitarySave"
								afterDelete={this.handleMilitaryDeletion}
							/>
						)}
					</div>}
					{this.state.emails.length > 0 && <div className={'col-3'}>
						{this.state.emails.map((email, i) =>
							<Objects.CustomerEmail
								key={i}
								id={email.pkey}
								binary_id={email.binary_id}
								parent={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								email={email}
								dataIdSave="EmailSave"
								afterDelete={this.handleEmailDeletion}
							/>
						)}
					</div>}
					{this.state.phones.length > 0 && <div className={'col-3'}>
						{this.state.phones.map((phone, i) =>
							<Objects.CustomerPhone
								key={i}
								id={phone.pkey}
								binary_id={phone.binary_id}
								parent={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								phone={phone}
								dataIdSave="PhoneSave"
								afterDelete={this.handlePhoneDeletion}
							/>
						)}
					</div>}
				</div>}
				{this.state.tab === 'identification' &&
				<div className={'row'}>
					<div className={'col-6'}>
						{this.state.identification !== false &&
						<Objects.CustomerIdentification
							id={this.state.identification ? this.state.identification.pkey : null}
							binary_id={this.state.identification ? this.state.identification.binary_id : null}
							parent={this.props.match.params.id}
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							identification={this.state.identification}
							dataIdSave="IdentificationSave"
							afterDelete={this.handleIdentificationDeletion}
							afterSave={this.handleIdentificationSave}

						/>}
					</div>
					<div className={'col-6'}>
						{this.state.permit !== false &&
						<Objects.CustomerNicsPermit
							id={this.state.permit ? this.state.permit.pkey : null}
							binary_id={this.state.permit ? this.state.permit.binary_id : null}
							parent={this.props.match.params.id}
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							permit={this.state.permit}
							dataIdSave="PermitSave"
							afterDelete={this.handleNicsPermitDeletion}
							afterSave={this.handleNicsPermitSave}
						/>}
					</div>
				</div>}
				{this.state.tab === 'history' &&
				<Collections.CustomersHistory
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' && this.props.userAccess <Access.Supervisor&&
				<Collections.LogsCustomer
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'duplicates' &&
					<Collections.CustomerDuplicates
						handleTab={this.handleTab}
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={() => {
							this.handleTabChange(null, 'details');
							this.refreshPage();
						}}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						loadContacts={this.loadContacts}
						baseUrl={this.props.baseUrl}
					/>}
					{(this.props.rootState && this.props.rootState.crmAvailable) &&
					this.state.tab === 'crm' &&
					<div className={'row'}>
						<div className={'col-md'}>
							<h4 className="section-title">CRM Tracked Fields</h4>
							{this.state.crmData ? (
								<table className="table" style={{fontSize: '0.95rem'}}>
									<tbody>
									<tr>
										<td style={{width: '35%', fontWeight: '600'}}>Language</td>
										<td>{this.state.crmData.language || '—'}</td>
									</tr>
									<tr>
										<td style={{fontWeight: '600'}}>Email Opt-In</td>
										<td>
											{this.state.crmData.email_opt_in
												? <span style={{color: '#28a745'}}>Opted in</span>
												: <span style={{color: '#6c757d'}}>Not opted in</span>}
											{this.state.crmData.email_opt_in_date &&
												<span className="text-muted" style={{marginLeft: '8px', fontSize: '0.85rem'}}>
													(since {this.state.crmData.email_opt_in_date.substring(0, 10)})
												</span>}
										</td>
									</tr>
									<tr>
										<td style={{fontWeight: '600'}}>SMS Opt-In</td>
										<td>
											{this.state.crmData.sms_opt_in
												? <span style={{color: '#28a745'}}>Opted in</span>
												: <span style={{color: '#6c757d'}}>Not opted in</span>}
											{this.state.crmData.sms_opt_in_date &&
												<span className="text-muted" style={{marginLeft: '8px', fontSize: '0.85rem'}}>
													(since {this.state.crmData.sms_opt_in_date.substring(0, 10)})
												</span>}
										</td>
									</tr>
									<tr>
										<td style={{fontWeight: '600'}}>Last Contact</td>
										<td>{this.state.crmData.last_contact_date
											? this.state.crmData.last_contact_date.substring(0, 10)
											: '—'}</td>
									</tr>
									{this.state.addresses.length > 0 && this.state.addresses[0] && (<>
										<tr>
											<td style={{fontWeight: '600'}}>Primary Address</td>
											<td>
												{[this.state.addresses[0].street_1,
													this.state.addresses[0].street_2,
													[this.state.addresses[0].city, this.state.addresses[0].state, this.state.addresses[0].zip].filter(Boolean).join(', '),
													this.state.addresses[0].country
												].filter(Boolean).join(', ')}
											</td>
										</tr>
									</>)}
									{this.state.emails.length > 0 && this.state.emails[0] && (<>
										<tr>
											<td style={{fontWeight: '600'}}>Primary Email</td>
											<td>{this.state.emails[0].email || '—'}</td>
										</tr>
									</>)}
									{this.state.phones.length > 0 && this.state.phones[0] && (<>
										<tr>
											<td style={{fontWeight: '600'}}>Primary Phone</td>
											<td>{this.state.phones[0].number || '—'}</td>
										</tr>
									</>)}
									</tbody>
								</table>
							) : (
								<span className="text-muted">Loading…</span>
							)}
						</div>
					</div>}
				</div>
				)
	}
};

export default Framework.Components.withRootState(Customer);
